import { ReadGrid } from './ReadGrid';

export function AmenitiesView({ amenities, notes }: { amenities: string[]; notes: string | null }) {
  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {amenities.length === 0 && (
          <span style={{ fontSize: 12.5, color: 'var(--nb-faint)', fontStyle: 'italic' }}>
            None listed
          </span>
        )}
        {amenities.map((a) => (
          <span key={a} className="nb-pill" style={{ height: 22, fontSize: 11 }}>
            {a}
          </span>
        ))}
      </div>
      <div style={{ marginTop: 14 }}>
        <div className="nb-eyebrow" style={{ marginBottom: 4 }}>
          Staff notes
        </div>
        <ReadGrid rows={[{ label: 'Notes', value: notes, full: true }]} />
      </div>
    </div>
  );
}
